// TODO: Determine why layers not displaying on map after a certain amount of time, no updating?

var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_map_manager = function (in_implements) {
    var implements = [new Class(OCS.Viewer.Interfaces.OlObject), new Class(OCS.Viewer.Interfaces.OlEvent)];
    if (!in_implements || !in_implements.length) {
        implements.combine([OCS.Viewer.Classes.MouseEventMapFeature, OCS.Viewer.Classes.LegendMapFeature, OCS.Viewer.Classes.CanvasMapFeature, OCS.Viewer.Classes.OverlayMapFeature, OCS.Viewer.Classes.TrackerMapFeature]);
    } else {
        implements.combine(in_implements);
    }
    if (OCS.Settings.debug) {
        implements.combine([OCS.Viewer.Classes.DebugMapFeature]);
    }
    OCS.Viewer.Classes.MapManager = new Class({
        Extends: OCS.Viewer.Classes.AbstractManager,
        Implements: implements,
        class_name: "MapManager",
        manager_name: 'MapManager',
        map_element: null,
        id: null,
        layer_groups: {},
        linked: false,
        link_bindings: [],
        state_map_bounds: null,
        active_radar_group_id: null,
        user_layer_count: 0,
        user_layer_group_id: null,
        data_callback_index: null,
        mouse_wheel_zoom: null,
        model: null,
        map_view: null,
        pan_interactions: [],
        zoom_interactions: [],
        drag_drop_interactions: [],
        events: {},
        options: {
            projection: OCS.Viewer.Config.default_projection,
            display_projection: OCS.Viewer.Config.default_display_projection,
            debug: false,
            debug_static_layers: false,
            mouse_position_string: 'mouse_position',
            event_namespace: '.map_manager',
            single_click_map_evnt: 'singleclick',
            background_draw: true,
            state_bottom_left: OCS.Viewer.Config.oklahoma_bottom_left_coordinates,
            state_top_right: OCS.Viewer.Config.oklahoma_top_right_coordinates
        },
        bound_methods: {},
        /**
         * Creates and initializes the OpenLayers map and initializes the LayerManager property of the map.
         *
         * @method initialize
         * @param element  {String}  The ID of the element that the OpenLayers map will be placed into
         * @param options  {Object}  An object of parameters to pass to the OpenLayers.Map method
         * @returns        {Object}  The Map object
         * @chainable
         */

        initialize: function (el, options, view_ops) {
            OCS.Viewer.Functions.init_utilities();
            if (OCS.Viewer.Functions.get_utilities().is_undefined(el)) {
                return;
            }
            var obj = el.retrieve('map');
            if (obj) {
                return obj;
            }
            this.setOptions(options);
            if (OCS.Settings.debug && this.start_debug) {
                this.start_debug();
            }
            this.set_element(el);

            this.define_interactions();
            //OpenLayers.Renderer.SVG.prototype.MAX_PIXEL = Number.MAX_VALUE; // Fix mask layer disappearing when zoomed in.
            this.create_map(el, view_ops);
            this.id = this.get_id();
            if (this.init_mouse_events) {
                this.init_mouse_events();
            }
            if (this.init_legend) {
                this.init_legend();
            }
            if (this.init_overlay) {
                this.init_overlay();
            }
            if (this.init_canvas_draw) {
                this.init_canvas_draw();
            }
            el.store('map', this);
        },
        /**
         * Creates and initializes the OpenLayers map object and places into "element" (emptying "element" 
         * before placing the map. The map will add a blank layer and then center the map to the default
         * OK view.
         *
         * @method create_map
         * @param element  {String}  The ID of the element that the OpenLayers map will be placed into
         * @returns        {Object}  An instance of the OpenLayers map
         */
        create_map: function (el, view_ops) {
            this.map_view = new OCS.Viewer.Classes.OlMapView(view_ops);
            var ol_options = {
                //layers: layers,
                target: el,
                view: this.map_view.get_view(),
                controls: [],
                interactions: [],
                renderer: "canvas"
            };
            this.set_ol_object(new ol.Map(ol_options));
            //this.ol_object.addLayer(layer); // add an empty layer so we can call set_map_center

            // Adding Keyboard interaction
            this.add_default_interaction();
            this.initialize_events();
            return this.ol_object;
        },
        /**
         * Sets listeners for various map events
         *
         * @method initialize_events
         * @return {Void}
         */
        initialize_events: function () {
            var em = OCS.Viewer.Functions.get_event_manager();
            var global_events = {
                REINIT_LAYERS: this.reinit_grouped_layers.bind(this)
            };
            Object.each(global_events, function (callback, event) {
                em.subscribe({'event_name': OCS.Viewer.Config.events[event], fire_immediately: true, 'callback': callback});
            });

            var init_events = {
                LOCK_ADVISORY_POPUP: this.remove_mouse_wheel_zoom,
                UNLOCK_ADVISORY_POPUP: this.add_mouse_wheel_zoom,
                UPDATE_LAYERS: this.on_update_layers,
                DESTROY_MAP: this.destroy,
                TOGGLE_LAYER_VISIBILITY: this.toggle_layer_visibility,
                RADAR_UPDATED: this.update_radar_layer
            };
            Object.each(init_events, function (callback, event) {
                var event_name = OCS.Viewer.Config.events[event];
                if (!this.bound_methods[event_name]) {
                    this.bound_methods[event_name] = callback.bind(this);
                }
                this.addEvent(event_name, this.bound_methods[event_name]);
            }.bind(this));

            this.add_change_map_selector_event(function (e) {
                setTimeout(function () {
                    this.resize();
                    this.render_map();
                }.bind(this), 200);
            }, this);

            this.addEvent('layer_group_added', this.on_layer_group_added.bind(this));
            this.addEvent('layer_group_removed', this.on_layer_group_removed.bind(this));

        },
        define_interactions: function () {
            this.pan_interactions = [];
            this.pan_interactions.push(new ol.interaction.DragPan());
            this.pan_interactions.push(new ol.interaction.KeyboardPan());
            this.zoom_interactions = [];
            this.zoom_interactions.push(new ol.interaction.DragZoom()); // This zoom made for some discolorations of the existing objects
            this.zoom_interactions.push(new ol.interaction.DoubleClickZoom());
            this.zoom_interactions.push(new ol.interaction.KeyboardZoom());
            this.zoom_interactions.push(new ol.interaction.PinchZoom());
            this.drag_drop_interactions = [];
            var drag_drop = new ol.interaction.DragAndDrop({
                formatConstructors: [
                    ol.format.GPX,
                    ol.format.GeoJSON,
                    ol.format.IGC,
                    ol.format.KML,
                    ol.format.TopoJSON
                ]
            });
            drag_drop.on('addfeatures', this.add_user_layer.bind(this));
            this.drag_drop_interactions.push(drag_drop);
        },

        initialize_map: function (mapJSON) {
            var lon = parseFloat(mapJSON.mapLon) || null,
                    lat = parseFloat(mapJSON.mapLat) || null;
            this.pan_to_point(lon, lat);
        },

        /**
         * Parses through the map object and adds the requested layers to the map
         *
         * @method initialize_layers
         * @param  {Object}  An object that holds map basics and an array of layers to add to the map
         * @return {Void}
         */
        initialize_layers: function (layers) {
            var dateObj = this.get_map_datetime_obj();
            var endtime = dateObj.get_end_epoch_time();
            var starttime = dateObj.get_start_epoch_time();
            var util = OCS.Viewer.Functions.get_utilities();
            if (layers && layers.length) {
                Object.each(layers, function (layer) {
                    layer.start_epoch_time = starttime;
                    layer.end_epoch_time = endtime;
                    layer.has_legend = false; // Applied globally to all layers, specific layers that have a legend will get the setting set in there respective add methods
                    layer.background_draw = false; // Applied globally to all layers, specific layers that use background drawing will have it turned on in there respective add methods
                    if (this.options.debug) {
                        console.debug('map_manager: layer-ops', layer);
                    }
                    switch (layer.type) {
                        case 'shape':
                            this.add_shape_layer(layer);
                            break;
                        case 'gradient':
                            this.add_gradient_layer(layer);
                            break;
                        case 'obs':
                            this.add_point_layer(layer);
                            break;
                        case 'contour':
                            this.add_contour_layer(layer);
                            break;
                        case 'radar':
                            this.add_radar_layer(layer);
                            break;
                        case 'vector':
                            this.add_wind_layer(layer);
                            break;
//                        case 'kmz':
//                            console.warn('map_manager: KMZ support needed to be added.');
//                            //this.add_KMZ_layer(layer);
//                            break;
                        case 'advisory':
                            if (util.is_undefined(layer.variables)) {
                                delete layer.variables;
                            }

                            this.add_advisory_layer(layer);
                            break;
                        case 'symbol':
                            if (layer.dataset === 'edu.ou.ocs.lightning') {
                                this.add_lightning_layer(layer);
                            }
                            break;
                    }
                }.bind(this));
            }
        },

        /**
         * Returns the OpenLayers map object for this instance
         *
         * @method get_map
         * @returns   {Object}  An instance of the OpenLayers Map Object
         */
        get_map: function () {
            return this.ol_object;
        }, // get_map
        get_map_view: function () {
            return this.map_view;
        },
        /**
         * Adds the default layers to the map
         *
         * @method add_default_layers
         * @returns   {Object} An instance of this map.
         * @chainable
         */
        add_default_layers: function () {
            var dateObj = this.get_map_datetime_obj();
            var startEnd = dateObj.get_server_epoch_time();
            this.add_shape_layer({"visible": true, "selected": false, "alpha": "0.2", "dataset": "edu.ou.ocs.usshapes", "line_color": "#000000FF", "width": "1.0", "variables": [{"parm": "outline", "units": "ok"}], "mask": true, "filled": false, "type": "shape", "start_epoch_time": startEnd, "end_epoch_time": startEnd, "grid": false});
            this.add_shape_layer({"visible": true, "selected": false, "alpha": "1.0", "dataset": "org.mesonet.okfirst.shapes", "line_color": "#000080FF", "width": "1.0", "variables": [{"parm": "counties", "units": "okfirst"}], "mask": false, "filled": false, "type": "shape", "start_epoch_time": startEnd, "end_epoch_time": startEnd, "grid": false});
        }, // add_default_layers
        add_layer_group: function (layer_group) {
            // Listen for render events on the group
            layer_group.addEvent('render', this.render_map.bind(this));

            // Add the layer group to the stored list
            this.layer_groups[layer_group.get_id()] = layer_group;

            // Add the layer group to the map object
            this.add_layer_to_map(layer_group.get_ol_object());
            this.fireEvent('layer_group_added', layer_group);
        },
        add_layer_to_map: function (layer) {
            if (this.ol_object) {
                this.ol_object.addLayer(layer);
            }
        }, // add_layer

        relay_event: function (event_name, event_data, delay) {
            var lg = this.get_layer_groups();
            Object.each(lg, function (layer_group, key) {
                if (delay) {
                    layer_group.fireEvent(event_name, event_data, delay);
                } else {
                    layer_group.fireEvent(event_name, event_data);
                }
            }.bind(this));
        },

        remove_layer_group: function (group_id) {
            var util = OCS.Viewer.Functions.get_utilities();
            if ((!util.is_undefined(group_id) && !util.is_null(group_id))) {
                var grouped_layer = this.layer_groups[group_id];
                if (grouped_layer) {
                    // Remove all the layers associated with the group
                    this.remove_layer_from_map(grouped_layer.get_ol_object());
                    grouped_layer.destroy();
                    delete this.layer_groups[group_id];
                    this.fireEvent('layer_group_removed', grouped_layer);
                }
            }
        },
        remove_layer_from_map: function (layer) {
            if (this.ol_object) {
                this.ol_object.removeLayer(layer);
            }
        },

        /**
         * Set the center of the map and zoom level and trigger movestart/end events and zoom change events
         *
         * @method pan_to_point
         * @param latitude  {Float} The latitude coordinate of the center point
         * @param longitude {Float} The longitude coordinate of the center point
         */
        pan_to_point: function (lon, lat) {
            lon = lon || OCS.Viewer.Config.oklahoma_lon;
            lat = lat || OCS.Viewer.Config.oklahoma_lat;
            if (this.map_view) {
                this.map_view.set_center([lon, lat]);
            }
        },
        zoom_to_oklahoma: function () {
            this.map_view.fit(this.get_state_map_bounds(), this.ol_object.getSize());
        },
        add_default_interaction: function () {
            this.add_map_interactions(this.pan_interactions);
            this.add_map_interactions(this.drag_drop_interactions);
        },
        remove_default_interaction: function () {
            this.remove_map_interactions(this.pan_interactions);
            this.remove_map_interactions(this.drag_drop_interactions);
        },
        add_zoom_control: function () {
            this.ol_object.addControl(new ol.control.Zoom());
        },
        add_zoom_interaction: function () {
            this.add_mouse_wheel_zoom();
            this.add_map_interactions(this.zoom_interactions);
        },
        add_mouse_wheel_zoom: function () {
            if (!this.mouse_wheel_zoom) {
                this.mouse_wheel_zoom = new ol.interaction.MouseWheelZoom();
                this.add_map_interactions([this.mouse_wheel_zoom]);
            }
        },
        remove_zoom_interaction: function () {
            this.remove_mouse_wheel_zoom();
            this.remove_map_interactions(this.zoom_interactions);
        },
        remove_mouse_wheel_zoom: function () {
            if (this.mouse_wheel_zoom) {
                this.remove_map_interactions([this.mouse_wheel_zoom]);
                this.mouse_wheel_zoom = null;
            }
        },
        add_map_interactions: function (interactions) {
            if (interactions.length || Object.keys(interactions).length) {
                Object.each(interactions, function (interaction) {
                    this.ol_object.addInteraction(interaction);
                }.bind(this));
            }
        },
        remove_map_interactions: function (interactions) {
            if (interactions.length || Object.keys(interactions).length) {
                Object.each(interactions, function (interaction) {
                    this.ol_object.removeInteraction(interaction);
                }.bind(this));
            }
        },
        /**
         * Adds an OpenLayers mouse position control to the map
         *
         * @method add_mouse_position_control
         */
        add_mouse_position_control: function () {
            if (this.ol_object) {
                this.ol_object.addControl(new ol.control.MousePosition({
                    coordinateFormat: ol.coordinate.createStringXY(4),
                    projection: this.options.display_projection,
                    // comment the following two lines to have the mouse position
                    // be placed within the map.
                    className: 'custom-mouse-position',
                    target: document.getElementById('mouse-position'),
                    undefinedHTML: '&nbsp;'
                }));
            }
        }, // add_layer_switcher_control

        //Indivdual Layer Add Functions*****
        add_basic_layer: function (options) {
            options.layer_class = "BaseLayer";
            return this.init_grouped_layer(options);
        }, // add_layer
        //POINT LAYER
        add_point_layer: function (options) {//dataset, variables, start, end) {
            options.grid = false;
            options.source_type = "Cluster";
            if (!options.cluster_distance) {
                options.cluster_distance = 30;
            }
            options.layer_class = "PointLayer";
            return this.init_grouped_layer(options);
        },
        //GRADIENT LAYER
        add_gradient_layer: function (options) {
            options.grid = true;
            options.has_legend = true; // This includes the legend functionality
            options.source_type = "GradientImageCanvas";
            options.layer_class = "GradientLayer";
            this.add_palette(options);
            return this.init_grouped_layer(options);
        },
        add_contour_layer: function (options) {
            options.grid = true;
            options.source_type = "Vector";
            options.layer_class = "ContourLayer";
            return this.init_grouped_layer(options);
        },
        add_wind_layer: function (options) {
            options.symbol_type = "windbarbs";
            options.source_type = "Cluster";
            if (!options.cluster_distance) {
                options.cluster_distance = 30;
            }

            var obj = "WindPointLayer";
            if (options.grid) {
                console.warn('map_manager: VectorCanvasLayer support needed to be added.');
                options.grid = false;
                //obj = "VectorCanvasLayer";
            }
            if (options.arrow) {
                options.symbol_type = "vectors";
            }
            options.layer_class = obj;
            return this.init_grouped_layer(options);
        },
        add_radar_layer: function (options) {
            options.grid = false;
            options.auto = true;
            options.has_legend = true; // This includes the legend functionality
            if (this.options.background_draw) {
                options.background_draw = true;
            }
            options.source_type = "RadarImageCanvas";
            options.layer_class = "RadarLayer";
            var radar_group = this.init_grouped_layer(options);
            this.active_radar_group_id = radar_group.get_id();
            return radar_group;
        },
        add_advisory_layer: function (options) {
            options.grid = false;
            options.source_type = "Advisory";
            options.auto = true;
            options.has_legend = true; // This includes the legend functionality
            // In the event filter_wfo_ids is undefined, default it to true
            if (!options.hasOwnProperty('filter_wfo_ids')) {
                options.filter_wfo_ids = true;
            }

            // Initialize layer
            options.layer_class = "AdvisoryLayer";
            return this.init_grouped_layer(options);
        },
        add_lightning_layer: function (options) {
            options.grid = false;
            options.source_type = "Lightning";
            options.layer_class = "LightningLayer";
            var model = this.get_model();
            // If we have a radar use it to set the reference coordinate
            if (model.contains_radar_layer()) {
                var radar_settings = model.get_map_radar_settings();
                var sel_site = OCS.Viewer.Functions.get_utilities().get_radar_site_properties(radar_settings.site);
                if (sel_site) {
                    options.lightning_reference_coord = [sel_site.lon, sel_site.lat];
                }
            }
            var lg = this.init_grouped_layer(options);
            return lg;
        },
        add_shape_layer: function (options) {
            var group;
            options.grid = false;
            if ((options.dataset.indexOf('countyroads') > -1) && !this.ol_objectTileLayerAdded) {
                options.source_type = "XYZ";
                options.layer_class = "MapTileLayer";
                group = this.init_grouped_layer(options);
                this.ol_objectTileLayerAdded = true;
            } else if (options.dataset.indexOf('countyroads') === -1) {
                options.source_type = "Vector";
                options.layer_class = "ShapeFileLayer";
                group = this.init_grouped_layer(options);
            }
            return group;
        },
        add_palette: function (options) {
            var pm = OCS.Viewer.Functions.get_palette_manager();
            if (options.hasOwnProperty('color_gradient')) {
                pm.create_palette(pm.get_palette_name_from_ops(options), OCS.Viewer.Functions.get_utilities().array_sort_with_prop(options.color_gradient, 'index'), options);
            }
        },
        update_radar_layer: function (radar_options) {
            var dateObj = this.get_map_datetime_obj();
            var new_group, options;
            var old_group = this.get_layer_group(this.active_radar_group_id);
            if (old_group) {
                options = {
                    "grid": old_group.get_gridded(),
                    "type": old_group.get_layer_type(),
                    "dataset": old_group.get_dataset(),
                    'variables': old_group.get_variables(),
                    "start_epoch_time": dateObj.get_start_epoch_time(),
                    "end_epoch_time": dateObj.get_end_epoch_time()
                };

                if (radar_options.product) {
                    options.variables[0].parm = radar_options.product.toUpperCase();
                }
                if (radar_options.site) {
                    // Make sure we have the site in our list.
                    var sel_site = OCS.Viewer.Functions.get_utilities().get_radar_site_properties(radar_options.site);
                    if (sel_site && radar_options.site !== options.variables[0].site) {
                        this.pan_to_point(sel_site.lon, sel_site.lat);
                        options.variables[0].site = radar_options.site.toUpperCase();
                        options.variables[0].units = radar_options.site.toUpperCase();
                    }
                }

                if (this.active_radar_group_id) {
                    new_group = this.replace_gl_same_type(this.active_radar_group_id, options);
                } else {
                    new_group = this.add_radar_layer(options);
                }
            }


            if (new_group) {
                this.active_radar_group_id = new_group.get_id();
            }
            this.relay_event(OCS.Viewer.Config.events.RADAR_UPDATED, [radar_options, this], 1);

        },
        add_user_layer: function (options) {
            var layer_ops = {layer_name: "User Data #" + this.user_layer_count, "layer_short_name": "User Data #" + this.user_layer_count};
            this.user_layer_count++;
            var layer = new OCS.Viewer.Classes.UserLayer(layer_ops);
            var source = new OCS.Viewer.Classes.ImageVectorSource({metadata: {grid: false, dataset: "userdata"}});
            source.create();
            source.add_features(options.features);
            source.ready = true;
            layer.set_source_obj(source);
            layer.create();
            layer.make_visible();
            this.layer_groups[layer.get_id()] = layer;

            // Add the layer to the map object
            this.add_layer_to_map(layer.get_ol_object());
            this.fireEvent('layer_group_added', layer);
            return layer;
//            var group = this.init_grouped_layer(options);
//            var req = group.get_request();
//            req.init_data = options.features;

        },
        bind_ol_map_properties: function (target_ocs_map) {
            var target_map = target_ocs_map.get_map();
            this.link_bindings.push(this.bind_property(target_map, this.options.mouse_position_string));
        },
        unbind_ol_map_properties: function (bindings) {
            this.link_bindings.each(function(bind_id) {
                this.unbind_property(bind_id);
            }.bind(this));
        },
        add_county_selector: function (county_data, county_limit, selector_callback) {
            var county_select = new OCS.Viewer.Classes.CountySelectFeature({selected_id: county_data, selectable_limit: county_limit});
            this.add_layer_to_map(county_select.layer.get_layer());
            this.ol_object.addInteraction(county_select.mouse_move_obj);
            this.ol_object.addInteraction(county_select.select_obj);
            county_select.addEvent('selected', selector_callback);
        },
        add_mesonet_site_selector: function (stid_to_use, selector_callback) {
            var site_select = new OCS.Viewer.Classes.SiteSelectFeature({selected_id: stid_to_use});
            this.add_layer_to_map(site_select.layer.get_layer());
            this.ol_object.addInteraction(site_select.mouse_move_obj);
            this.ol_object.addInteraction(site_select.select_obj);
            site_select.addEvent('selected', selector_callback);
        },
        add_radar_selector: function (radar_to_use, selector_callback) {
            var radar_select = new OCS.Viewer.Classes.RadarSelectFeature({selected_id: radar_to_use});
            this.add_layer_to_map(radar_select.layer.get_layer());
            this.add_layer_to_map(radar_select.range_layer.get_layer());
            this.ol_object.addInteraction(radar_select.mouse_move_obj);
            this.ol_object.addInteraction(radar_select.select_obj);
            radar_select.addEvent('selected', selector_callback);
        },
        get_layer_index: function (layer) {
            var layers = this.ol_object.getLayers();
            var length = layers.getLength();
            for (var i = 0; i < length; i++) {
                if (layer === layers.item(i)) {
                    return i;
                }
            }
            return -1;
        },
        set_layer_index: function (layer, index) {
            var layers = this.ol_object.getLayers();
            var old_index = this.get_layer_index(layer);
            if (old_index !== -1) {
                layers.removeAt(old_index);
            }
            layers.insertAt(index, layer);
        },
        get_map_bounds: function () {
            return this.map_view.calculate_extent(this.ol_object.getSize());
        },
        get_state_map_bounds: function () {
            if (!this.state_map_bounds) {
                if (!this.map_view) {
                    this.map_view = new OCS.Viewer.Classes.OlMapView();
                }
                var cooBottomLeft = ol.proj.transform(this.options.state_bottom_left, this.map_view.get_display_projection(), this.map_view.get_projection());
                var cooTopRight = ol.proj.transform(this.options.state_top_right, this.map_view.get_display_projection(), this.map_view.get_projection());
                this.state_map_bounds = new ol.extent.boundingExtent([cooBottomLeft, cooTopRight]);
            }
            return this.state_map_bounds;
        },
        get_viewport: function () {
            if (this.ol_object) {
                return this.ol_object.getViewport();
            }
        },
        render_map: function () {
            if (this.ol_object) {
                this.ol_object.render();
            }
        },
        resize: function () {
            if (this.ol_object) {
                this.ol_object.updateSize();
            }
        },
        get_size: function () {
            if (this.ol_object) {
                return this.ol_object.getSize();
            }
        },
        set_size: function (size) {
            if (this.ol_object) {
                return this.ol_object.setSize(size);
            }
        },
        get_element: function () {
            return this.map_element;
        },
        set_element: function (el) {
            this.map_element = el;
        },
        /*****
         * 
         * 
         * Event Fires
         * 
         * 
         */

        layer_visibility: function (group_id, layer_visibility) {
            var map_cntrllr = this.get_map_controller();
            if (map_cntrllr) {
                map_cntrllr.get_panel_options().fireEvent(OCS.Viewer.Config.events.LAYER_VISIBILITY_CHANGED, {group_id: group_id, condition: layer_visibility});
            }
        },

        update_panel_options: function () {
            if (!this.update_panel_options_timeout) {
                this.update_panel_options_timeout = setTimeout(function () {
                    this.update_panel_options_timeout = null;
                    this.fireEvent('update_panel_options', this);
                }.bind(this), 500);
            }
        },
        /*****
         * 
         * 
         * Event Listeners
         * 
         * 
         */
        on_model_change: function (delta, model) {
            var keys = Object.keys(delta);
            var value;
            keys.each(function (key) {
                value = delta[key];
                switch (key) {
                    case "radar_site":
                        this.fireEvent(OCS.Viewer.Config.events.RADAR_UPDATED, [{site: value}, this], 1);
                        break;
                    case "radar_product":
                        this.fireEvent(OCS.Viewer.Config.events.RADAR_UPDATED, [{product: value}, this], 1);
                        break;
                }

            }, this);
        },
        on_layer_group_added: function (lg) {
            this.update_panel_options();
        },
        on_layer_group_removed: function (lg) {
            this.update_panel_options();
        },
        on_new_data_callback_fired: function (e) {

        },
        on_update_layers: function (e) {

        },

        /*****
         *
         * 
         * Layer Group Management methods
         *
         *
         */
        init_grouped_layer: function (options) {
            var util = OCS.Viewer.Functions.get_utilities();
            if (util.is_null(options)) {
                return;
            }

            // Determine all the layers associated with this group and add them to it
            var grouped_layers = this.create_grouped_layers(options);
            if (!util.is_undefined(options.dataset) && !util.is_undefined(OCS.Datasets[options.dataset])) {
                grouped_layers.fireEvent('add_dataset', OCS.Datasets[options.dataset]);
            }

            switch (grouped_layers.get_datatype()) {
                case "shapefile":
                case "unknown":
                    grouped_layers.set_static(true);
                    /* falls through */
                case "nids":
                case "netcdf":
                case "lightning":
                case "advisories":
                    //mesonet, and radar
                    grouped_layers.fireEvent('init');
                    break;
                default:
                    if (this.options.debug) {
                        console.log('map_manager ' + this.map_selector + ': Default layer group being created.');
                    }
                    break;
            }

            if (this.debug_controls) {
                this.debug_controls();
            }
            return grouped_layers;
        },
        create_grouped_layers: function (options) {
            // Based on the layer name, get the appropriate group if not defined, use the standard layer group.
            var layer_group_class = this.get_layer_group_class(options);
            var layer_group_options = this.create_layer_group_options(options);
            var layer_group = new layer_group_class(layer_group_options);
            layer_group.fireEvent('add_map_datetime_obj', this.get_map_datetime_obj());

            // Add the group to the map
            this.add_layer_group(layer_group);
            // Turn on the legend if its defaulted to on.
            if (options.legend) {
                layer_group.addEvent('ready', function () {
                    this.toggle_layer_legend_visibility({id: layer_group.get_id()});
                }.bind(this));
            }

            return layer_group;
        },
        create_layer_group_options: function (options) {
            var layer_style_ops = this.create_layer_style_options(options);
            var layer_source_ops = this.create_layer_source_options(options);
            var layer_group_options = {
                animation_step: this.options.step,
                init_start_timestamp_epoch: options.start_epoch_time,
                init_end_timestamp_epoch: options.end_epoch_time,
                layer_class: options.layer_class,
                layer_style_ops: layer_style_ops,
                layer_source_ops: layer_source_ops,
                layer_type: options.type,
                visible: true,
            };
            if (options.hasOwnProperty('max_val') && options.hasOwnProperty('min_val')) {
                layer_group_options.max_val = parseFloat(options.max_val);
                layer_group_options.min_val = parseFloat(options.min_val);
            }
            if (options.hasOwnProperty('auto')) {
                layer_group_options.auto = options.auto;
            }
            if (options.hasOwnProperty('has_legend')) {
                layer_group_options.has_legend = options.has_legend;
            }
            if (options.hasOwnProperty('background_draw')) {
                layer_group_options.background_draw = options.background_draw;
            }

            if (options.hasOwnProperty('layer_name')) {
                layer_group_options.layer_name = options.layer_name;
            }
            if (options.hasOwnProperty('layer_short_name')) {
                layer_group_options.layer_short_name = options.layer_short_name;
            }


            // Map related options
            if (options.hasOwnProperty('mapApiKey')) {
                layer_group_options.mapApiKey = options.mapApiKey;
            }
            if (options.hasOwnProperty('mapUsername')) {
                layer_group_options.mapUsername = options.mapUsername;
            }
            if (options.hasOwnProperty('mapStyleName')) {
                layer_group_options.mapStyleName = options.mapStyleName;
            }

            return layer_group_options;
        },
        create_layer_style_options: function (options) {
            var style_ops = {
                alpha: options.alpha
            };
            if (options.hasOwnProperty('variables') && options.variables.length === 1) {
                style_ops.value_var = options.variables[0].parm;
            }
            if (options.hasOwnProperty('filled')) {
                style_ops.filled = options.filled;
            }
            if (options.hasOwnProperty('fillOpacity')) {
                style_ops.fill_opacity = options.fillOpacity;
            }
            if (options.hasOwnProperty('highlightOpacity')) {
                style_ops.highlight_opacity = options.highlightOpacity;
            }
            if (options.hasOwnProperty('highlightWidthMult')) {
                style_ops.highlight_width_mult = options.highlightWidthMult;
            }
            if (options.hasOwnProperty('mask')) {
                style_ops.mask = options.mask;
            }
            if (options.hasOwnProperty('labelPrecision')) {
                style_ops.label_precision = options.labelPrecision;
            }
            if (options.hasOwnProperty('label_contours')) {
                style_ops.label_contours = options.label_contours;
            }
            if (options.hasOwnProperty('line_color')) {
                style_ops.line_color = options.line_color;
            }
            if (options.hasOwnProperty('line_width')) {
                style_ops.line_width = options.line_width;
            }
            if (options.hasOwnProperty('location')) {
                style_ops.location = options.location;
            }
            if (options.hasOwnProperty('outline')) {
                style_ops.outline = options.outline;
            }
            if (options.hasOwnProperty('precision')) {
                style_ops.precision = options.precision;
            }
            if (options.hasOwnProperty('prefix')) {
                style_ops.prefix = options.prefix;
            }
            if (options.hasOwnProperty('suffix')) {
                style_ops.suffix = options.suffix;
            }
            if (options.hasOwnProperty('symbol_type')) {
                style_ops.symbol_type = options.symbol_type;
            }
            if (options.hasOwnProperty('width')) {
                style_ops.width = options.width;
            }
            return style_ops;
        },
        create_layer_source_options: function (options) {
            var source_ops = {
                metadata: {
                    source_type: options.source_type,
                    dataset: options.dataset || null,
                    grid: options.grid
                },
                init: {
                }
            };
            if (OCS.Datasets[options.dataset] && OCS.Datasets[options.dataset].get_datatype() === "netcdf") {
                // If its netcdf we need to make a modification to insert if its type grd or obs for the node subscription
                if (source_ops.metadata.grid) {
                    source_ops.metadata.type = "grd"; // Metadata for the node subscription
                } else {
                    source_ops.metadata.type = "obs"; // Metadata for the node subscription
                }
            }
            if (options.variables) {
                source_ops.metadata.variables = options.variables;
            }

            if (options.hasOwnProperty('auto')) {
                source_ops.init.auto = options.auto;
            }
            if (options.source_type === 'Cluster' && options.cluster_distance) {
                source_ops.init.cluster_distance = options.cluster_distance;
            }
            if (options.hasOwnProperty('interval')) {
                source_ops.init.interval = options.interval;
            }
            if (options.hasOwnProperty('mask')) {
                source_ops.init.mask = options.mask;
            }
            if (options.hasOwnProperty('max_val')) {
                source_ops.init.max_val = options.max_val;
            }
            if (options.hasOwnProperty('min_val')) {
                source_ops.init.min_val = options.min_val;
            }

            // Advisory options
            if (options.hasOwnProperty('filter_wfo_ids')) {
                source_ops.metadata.filter_wfo_ids = options.filter_wfo_ids;
            }
            if (options.hasOwnProperty('filtered_wfo_ids')) {
                source_ops.metadata.filtered_wfo_ids = options.filtered_wfo_ids;
            }
            if (options.hasOwnProperty('warning_types')) {
                source_ops.metadata.warning_types = options.warning_types;
            }
            if (options.hasOwnProperty('lightning_reference_coord')) {
                source_ops.reference_coord = options.lightning_reference_coord;
            }
            if (options.hasOwnProperty('lightning_reference_dist')) {
                source_ops.reference_dist = options.lightning_reference_dist;
            }
            return source_ops;
        },
        /***
         * Return all the layer groups keyed by there group_ids
         * 
         * @returns {layer_groups}
         */
        get_layer_groups: function () {
            return this.layer_groups;
        },
        /***
         * Get a layer group object given its group_id.
         * 
         * @param {String} group_id
         * @returns {layer_group}
         */
        get_layer_group: function (group_id) {
            if (group_id in this.layer_groups) {
                return this.layer_groups[group_id];
            }
        },
        get_layer_group_class: function (options) {
            var test_group = options.layer_class + "Group";
            var layer_group_class;
            var util = OCS.Viewer.Functions.get_utilities();
            if ((util.is_undefined(OCS.Viewer.Classes[test_group]) || util.is_null(OCS.Viewer.Classes[test_group])) && util.is_undefined(OCS.Viewer.Functions["define_" + test_group])) {
                layer_group_class = OCS.Viewer.Classes.LayerGroup;
            } else {
                if (!util.is_undefined(OCS.Viewer.Functions["define_" + test_group])) {
                    layer_group_class = OCS.Viewer.Functions["define_" + test_group](null, null, options);
                } else {
                    layer_group_class = OCS.Viewer.Classes[test_group];
                }
            }
            return layer_group_class;
        },
        get_layer_group_with_name: function (name) {
            var lg = Object.values(this.get_layer_groups());
            for (var i = 0; i < lg.length; i++) {
                if (lg[i].get_layer_name() === name) {
                    return lg[i];
                }
            }
        },
        /**
         * Replace an existing group with the same type of group as existed previously. 
         * 
         * @param {type} old_group_id
         * @param {type} new_group_options
         * @returns {new_group}
         */
        replace_gl_same_type: function (old_group_id, new_group_options) {
            var old_group = this.get_layer_group(old_group_id);
            if (old_group) {
                new_group_options.layer_class = old_group.get_layer_class();
                return this.replace_grouped_layer(old_group_id, new_group_options);
            }
        },
        replace_grouped_layer: function (old_group_id, new_group_options) {
            var old_group_index = null;
            var old_group = this.get_layer_group(old_group_id);
            var legend_active = false;
            var util = OCS.Viewer.Functions.get_utilities();
            if (old_group) {
                old_group_index = this.get_layer_index(old_group.get_ol_object());
                legend_active = old_group.get_layer_legend_visibility();
                new_group_options.has_legend = old_group.has_legend;
                new_group_options.dataset = old_group.get_dataset();
                new_group_options.grid = old_group.get_gridded();
                new_group_options.source_type = old_group.get_source_type();
                new_group_options.type = old_group.get_gridded();
                new_group_options.visible = old_group.is_visible();
                this.remove_layer_group(old_group_id);
            }
            if (!util.is_undefined(new_group_options) && !util.is_null(new_group_options)) {
                var new_group = this.init_grouped_layer(new_group_options);
                this.set_layer_index(new_group.get_ol_object(), old_group_index);
                if (legend_active && this.toggle_layer_legend_visibility) {
                    new_group.addEvent('ready', function () {
                        this.toggle_layer_legend_visibility({id: new_group.get_id()});
                    }.bind(this));
                }
                var map_contr = this.get_map_controller();
                if (map_contr) {
                    map_contr.map_event(OCS.Viewer.Config.events.UPDATE_LAYERS, new_group.get_latest_timestamp_epoch());
                }

                return new_group;
            }
        },
        /**
         * Hides/Shows a grouped layer based on its current visibility  
         *
         * @method toggle_layer_visibility
         * @param {Integer} Group id of the grouped layer
         * @returns void
         */
        toggle_layer_visibility: function (group) {
            var group_id = group.id;
            var vis = !this.layer_groups[group_id].is_visible();
            this.layer_groups[group_id].set_visible(vis);
            this.layer_visibility(group_id, vis);
        },

        reinit_grouped_layers: function () {
            // Loop through all the layer groups and have them renit
            Object.each(this.layer_groups, function (layer_group) {
                layer_group.init();
            }.bind(this));
        },
        get_what_is_not_visible: function () {
            var lg = this.get_layer_groups();
            var is_not_visible = {};
            Object.each(lg, function (layer_group, key) {
                if (!layer_group.is_visible() && layer_group.get_show_in_url()) {
                    is_not_visible[layer_group.get_layer_name()] = false;
                }
            }.bind(this));
            return is_not_visible;
        },

        /*
         **************
         * 
         * 
         * Frame related methods
         * 
         **************
         */

        remove_all_grouped_layers: function () {
            var group_id;
            var group_keys = Object.keys(this.get_layer_groups());
            var i = 0;
            for (i; i < group_keys.length; i++) {
                group_id = group_keys[i];
                this.layer_groups[group_id].destroy();
                delete this.layer_groups[group_id];
            }
        },
        get_html_controller: function () {
            return this.get_element().retrieve('viewer_html');
        },
        get_map_controller: function () {
            return this.get_element().retrieve('viewer');
        },
        get_map_datetime_obj: function () {
            if (!this.map_datetime_obj) {
                this.set_map_datetime_obj(new OCS.Viewer.Classes.MapDateTime());
            }
            return this.map_datetime_obj;
        },
        set_map_datetime_obj: function (date_obj) {
            this.map_datetime_obj = date_obj;
        },
        get_model: function () {
            return this.model;
        },
        set_model: function (model) {
            this.model = model;
            model.addEvent('change', this.on_model_change.bind(this));
        },
        destroy: function () {
            if (this.stop_debug) {
                this.stop_debug();
            }
            if (this.options.debug) {
                console.debug("map_manager: Map being destroyed!", this);
            }

            if (this.update_panel_options_timeout) {
                clearTimeout(this.update_panel_options_timeout);
            }
            if (this.remove_tracker) {
                this.remove_tracker();
            }
            this.unbind_ol_map_properties();
            if (this.map_view) {
                this.map_view.destroy();
                this.map_view = null;
            }
            this.mouse_over_map = false;
            this.map_datetime_obj = null;
            this.remove_all_events();
            this.remove_all_grouped_layers();
            this.removeEvents();
            if (this.ol_object) {
                this.ol_object.getLayers().getArray().forEach(function (layer) {
                    this.ol_object.removeLayer(layer);
                }.bind(this));
                this.ol_object.getOverlays().forEach(function (overlay) {
                    this.ol_object.removeOverlay(overlay);
                }.bind(this));
                this.ol_object.getControls().forEach(function (control) {
                    this.ol_object.removeControl(control);
                }.bind(this));
                this.ol_object.getInteractions().forEach(function (interaction) {
                    this.ol_object.removeInteraction(interaction);
                }.bind(this));
                this.ol_object.setTarget(null);
            }
            if(this.map_element) {
                this.map_element.store('map', null);
                this.map_element.empty();
                this.map_element = null;
            }
            this.ol_object = null;
        }
    });
};
OCS.Viewer.Functions.define_map_manager();
